import GalleryView from "@/components/GalleryView";

const GalleryPage = () => {
  return (
    <section className="relative flex w-full">
      <GalleryView />
    </section>
  );
};

export default GalleryPage;
